<div class="dz-grid">
	<div class="dz-row">
		<div class="text-16 text-16 padding-8" dcrHTMLKey="HOME_PAGE_GREY_CARD_SECTION_HEADER">Select up to 3 model portfolios across all goals to see comparison</div>
	</div>
	<div class="dz-row">
		<ng-container *ngFor="let family of familyDataArr; let rowIndex = index">
			<div class="dz-col-xl-12 padding-bottom-16" *ngIf="portfolioDataMap.get(family.familyId?.formattedValue)?.length">
				<mb-portfolio-selection-card
					[attr.data-cy]="family.familyId?.formattedValue"
					[familyData]="family"
					[portfolioData]="portfolioDataMap.get(family.familyId?.formattedValue)"
					[selectedModelIds]="selectedModelIds"
					(selectedModelsChanged)="selectedModels.emit($event)"
				></mb-portfolio-selection-card>
			</div>
		</ng-container>
		<ac-disclosure [isExpandable]="false" dcrKey="HOME_PAGE_GREY_CARD_SECTION_DISCLOSURE"></ac-disclosure>
	</div>
</div>
